module.exports = __webpack_public_path__ + "img/instagram-l.d996a363.svg";